<template>
  <div class="description-container">
    {{$t('common.desc-1')}}
      <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank"> {{$t('common.policy')}}</a>{{$t('common.more-1')}}{{$t('common.point')}}  {{$t('common.desc-2')}}
    <a v-omnisdk_open href="https://www.mattel163.com/support.html" target="_blank"> {{$t('common.support')}}</a>{{$t('common.more-2')}}{{$t('common.point')}}
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>

.description-container {
  line-height: 0.32rem;
  font-size: 0.293rem;
  padding: 0.15rem 0.64rem;
  position: fixed;
  bottom: 2.4rem;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
  left: 0;
  right: 0;
  text-align: center;
  overflow: hidden;
  background-color: #f1f1f1;
  text-align: left;
  a {
    color: #4990e2;
  }
}

@media screen and (orientation: landscape)   {
  .description-container {
    bottom: 1.9rem;
  }
}

@media  screen and (max-height: 668px) {
  .description-container {
    font-size: 0.24rem !important;
    line-height: 0.28rem !important;
  }
}

@media screen and (orientation: landscape)  and (min-width: 668px) {
  .description-container {
    font-size: 0.293rem !important;
    line-height: 0.32rem !important;
  }
}
// 小平手机
 @media (orientation: landscape) and (max-width: 768px) and (max-height:475px) {
    .description-container {
      font-size: 0.24rem !important;
      line-height: 0.24rem !important;
    }

  }
</style>
